export const extractParams = (url) => {
    const params = url.split('?')[1];
    if (!params) {
        return {};
    }
    return params.split('&').reduce((acc, param) => {
        const [key, value] = param.split('=');
        acc[key] = value;
        return acc;
    }, {});
}